import { axios } from '@/services/axios';

const getOutboundCaller = async (currentCompany) => {
    const res = await axios.get(
        `/company/${currentCompany}/numbers/presentable/list`,
    );
    return res.data;
};

export default getOutboundCaller;
